import { useUserStore } from '~/stores/user'

export default defineNuxtPlugin(async () => {
  const userStore = useUserStore()
  try {
    await userStore.getUser()
  } catch (err) {
    console.error(err)
  }
  return {
    provide: {
      userStore,
    },
  }
})
